export default __webpack_public_path__ + "static/media/after-start.0e4201b0.svg";